var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHandcuffs = function SvgHandcuffs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -50 158 190",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f2",
    x: -2,
    y: -2,
    width: "500%",
    height: "500%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 2,
    result: "blur"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    d: "M101.07,59.26A8,8,0,0,1,99.46,57a8.25,8.25,0,0,1,3.88-11L116,39.87a8.27,8.27,0,1,1,7.15,14.91l-12.67,6.08a8.26,8.26,0,0,1-9.42-1.6ZM124.3,42.61a6.67,6.67,0,0,0-7.59-1.29L104,47.4a6.65,6.65,0,0,0-3.13,8.89h0a6.67,6.67,0,0,0,8.9,3.13l12.67-6.08a6.68,6.68,0,0,0,3.13-8.89A6.38,6.38,0,0,0,124.3,42.61Z",
    transform: "translate(-22.67 -39.06)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    d: "M120.05,54.78a8.33,8.33,0,0,1-2-3.21,8.19,8.19,0,0,1,.44-6.31h0a8.27,8.27,0,0,1,11.08-3.73l12.59,6.25a8.27,8.27,0,0,1-7.36,14.81l-12.59-6.25A8.51,8.51,0,0,1,120.05,54.78Zm23.16-4.3a6.51,6.51,0,0,0-1.75-1.26L128.87,43a6.66,6.66,0,0,0-8.94,3h0a6.65,6.65,0,0,0,3,8.93l12.59,6.26a6.67,6.67,0,0,0,7.68-10.68Z",
    transform: "translate(-22.67 -39.06)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    d: "M136.73,83.08l-.3-.31a8.18,8.18,0,0,1-2.11-6l.71-14a8.29,8.29,0,0,1,8.68-7.84h0a8.28,8.28,0,0,1,7.83,8.68l-.71,14a8.28,8.28,0,0,1-8.68,7.83A8.18,8.18,0,0,1,136.73,83.08Zm6.9-26.55a6.68,6.68,0,0,0-7,6.32l-.72,14a6.62,6.62,0,0,0,1.71,4.8,6.76,6.76,0,0,0,4.61,2.2,6.69,6.69,0,0,0,7-6.33l.72-14a6.68,6.68,0,0,0-6.32-7Z",
    transform: "translate(-22.67 -39.06)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    d: "M92,60.88a.86.86,0,0,1-.15-.22.8.8,0,0,1,.37-1.07l7.66-3.67a.79.79,0,0,1,1.07.37.8.8,0,0,1-.38,1.07L92.86,61A.79.79,0,0,1,92,60.88Z",
    transform: "translate(-22.67 -39.06)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    d: "M140.27,91.7a.75.75,0,0,1-.23-.64l.65-6.53a.81.81,0,0,1,.88-.71.79.79,0,0,1,.71.87l-.65,6.53a.79.79,0,0,1-.88.71A.75.75,0,0,1,140.27,91.7Z",
    transform: "translate(-22.67 -39.06)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M38.64,95.06A24.3,24.3,0,0,1,45.33,56h0a24.28,24.28,0,1,1-6.69,39.05ZM46,57.46A22.68,22.68,0,1,0,76.28,68.1,22.71,22.71,0,0,0,46,57.46Z",
    transform: "translate(-22.67 -39.06)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M81.78,59.83a.82.82,0,0,1-.16-.22A.81.81,0,0,1,82,58.54l3.47-1.67a.8.8,0,0,1,1.07.38.79.79,0,0,1-.37,1.06L82.69,60A.8.8,0,0,1,81.78,59.83Z",
    transform: "translate(-22.67 -39.06)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M32.39,101.39a33.17,33.17,0,0,1,45-48.67l9.32-4.47a.79.79,0,0,1,1.06.37L98.68,71.31a.81.81,0,0,1-.38,1.07L89,76.85a33.19,33.19,0,0,1-56.59,24.54ZM86.7,50l-9.07,4.36a.81.81,0,0,1-.88-.13A31.56,31.56,0,1,0,87.37,76.39a.79.79,0,0,1,.45-.76l9.07-4.35Zm-9.42,3.63h0Z",
    transform: "translate(-22.67 -39.06)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M119.64,148.8A24.27,24.27,0,1,1,160.94,134h0a24.26,24.26,0,0,1-41.3,14.76Zm33.16-33.22a22.67,22.67,0,1,0,6.55,18.3h0A22.62,22.62,0,0,0,152.8,115.58Z",
    transform: "translate(-22.67 -39.06)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M144.73,100.91a.75.75,0,0,1-.23-.64l.34-3.49a.81.81,0,0,1,.88-.72.8.8,0,0,1,.71.88l-.34,3.49a.8.8,0,0,1-.88.71A.75.75,0,0,1,144.73,100.91Z",
    transform: "translate(-22.67 -39.06)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    d: "M113.37,155.09a33.15,33.15,0,0,1,13.12-55l1-10.29a.79.79,0,0,1,.87-.71l25,2.5a.8.8,0,0,1,.72.87l-1,10.29a33.16,33.16,0,1,1-39.75,52.33ZM129,90.77l-1,10a.78.78,0,0,1-.56.68,31.56,31.56,0,1,0,24.42,2.44.8.8,0,0,1-.41-.78l1-10Z",
    transform: "translate(-22.67 -39.06)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    filter: "url(#f2)",
    d: "M101.07,59.26A8,8,0,0,1,99.46,57a8.25,8.25,0,0,1,3.88-11L116,39.87a8.27,8.27,0,1,1,7.15,14.91l-12.67,6.08a8.26,8.26,0,0,1-9.42-1.6ZM124.3,42.61a6.67,6.67,0,0,0-7.59-1.29L104,47.4a6.65,6.65,0,0,0-3.13,8.89h0a6.67,6.67,0,0,0,8.9,3.13l12.67-6.08a6.68,6.68,0,0,0,3.13-8.89A6.38,6.38,0,0,0,124.3,42.61Z",
    transform: "translate(-22.67 -39.06)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    filter: "url(#f2)",
    d: "M120.05,54.78a8.33,8.33,0,0,1-2-3.21,8.19,8.19,0,0,1,.44-6.31h0a8.27,8.27,0,0,1,11.08-3.73l12.59,6.25a8.27,8.27,0,0,1-7.36,14.81l-12.59-6.25A8.51,8.51,0,0,1,120.05,54.78Zm23.16-4.3a6.51,6.51,0,0,0-1.75-1.26L128.87,43a6.66,6.66,0,0,0-8.94,3h0a6.65,6.65,0,0,0,3,8.93l12.59,6.26a6.67,6.67,0,0,0,7.68-10.68Z",
    transform: "translate(-22.67 -39.06)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    filter: "url(#f2)",
    d: "M136.73,83.08l-.3-.31a8.18,8.18,0,0,1-2.11-6l.71-14a8.29,8.29,0,0,1,8.68-7.84h0a8.28,8.28,0,0,1,7.83,8.68l-.71,14a8.28,8.28,0,0,1-8.68,7.83A8.18,8.18,0,0,1,136.73,83.08Zm6.9-26.55a6.68,6.68,0,0,0-7,6.32l-.72,14a6.62,6.62,0,0,0,1.71,4.8,6.76,6.76,0,0,0,4.61,2.2,6.69,6.69,0,0,0,7-6.33l.72-14a6.68,6.68,0,0,0-6.32-7Z",
    transform: "translate(-22.67 -39.06)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    filter: "url(#f2)",
    d: "M92,60.88a.86.86,0,0,1-.15-.22.8.8,0,0,1,.37-1.07l7.66-3.67a.79.79,0,0,1,1.07.37.8.8,0,0,1-.38,1.07L92.86,61A.79.79,0,0,1,92,60.88Z",
    transform: "translate(-22.67 -39.06)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "linePink",
    filter: "url(#f2)",
    d: "M140.27,91.7a.75.75,0,0,1-.23-.64l.65-6.53a.81.81,0,0,1,.88-.71.79.79,0,0,1,.71.87l-.65,6.53a.79.79,0,0,1-.88.71A.75.75,0,0,1,140.27,91.7Z",
    transform: "translate(-22.67 -39.06)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M38.64,95.06A24.3,24.3,0,0,1,45.33,56h0a24.28,24.28,0,1,1-6.69,39.05ZM46,57.46A22.68,22.68,0,1,0,76.28,68.1,22.71,22.71,0,0,0,46,57.46Z",
    transform: "translate(-22.67 -39.06)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M81.78,59.83a.82.82,0,0,1-.16-.22A.81.81,0,0,1,82,58.54l3.47-1.67a.8.8,0,0,1,1.07.38.79.79,0,0,1-.37,1.06L82.69,60A.8.8,0,0,1,81.78,59.83Z",
    transform: "translate(-22.67 -39.06)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M32.39,101.39a33.17,33.17,0,0,1,45-48.67l9.32-4.47a.79.79,0,0,1,1.06.37L98.68,71.31a.81.81,0,0,1-.38,1.07L89,76.85a33.19,33.19,0,0,1-56.59,24.54ZM86.7,50l-9.07,4.36a.81.81,0,0,1-.88-.13A31.56,31.56,0,1,0,87.37,76.39a.79.79,0,0,1,.45-.76l9.07-4.35Zm-9.42,3.63h0Z",
    transform: "translate(-22.67 -39.06)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M119.64,148.8A24.27,24.27,0,1,1,160.94,134h0a24.26,24.26,0,0,1-41.3,14.76Zm33.16-33.22a22.67,22.67,0,1,0,6.55,18.3h0A22.62,22.62,0,0,0,152.8,115.58Z",
    transform: "translate(-22.67 -39.06)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M144.73,100.91a.75.75,0,0,1-.23-.64l.34-3.49a.81.81,0,0,1,.88-.72.8.8,0,0,1,.71.88l-.34,3.49a.8.8,0,0,1-.88.71A.75.75,0,0,1,144.73,100.91Z",
    transform: "translate(-22.67 -39.06)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "lineBlue",
    filter: "url(#f2)",
    d: "M113.37,155.09a33.15,33.15,0,0,1,13.12-55l1-10.29a.79.79,0,0,1,.87-.71l25,2.5a.8.8,0,0,1,.72.87l-1,10.29a33.16,33.16,0,1,1-39.75,52.33ZM129,90.77l-1,10a.78.78,0,0,1-.56.68,31.56,31.56,0,1,0,24.42,2.44.8.8,0,0,1-.41-.78l1-10Z",
    transform: "translate(-22.67 -39.06)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandcuffs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handcuffs.7a373a59.svg";
export { ForwardRef as ReactComponent };